// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tourBtn[data-v-d066ad78] {\n    border: solid 1px white;\n    background-color: rgba(0, 0, 0, 0);\n    color: white;\n    margin-right: 10px;\n    margin-left: 10px;\n    margin-top: 5px;\n}\n.tourBtn[data-v-d066ad78]:hover {\n    color: white;\n}\n.orange[data-v-d066ad78] {\n  color: orange;\n}\n", ""]);
// Exports
module.exports = exports;
